var _linearGradient, _linearGradient2, _linearGradient3, _mask, _mask2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 11 12",
    width: 11,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee1b44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd153c"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0543a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003893"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#f"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.19625244c.22298362 0 .55454063.10052872.73420129.22030249l8.60969937 5.73979959c.3644234.24294891.2974179.43989792-.1377772.43989792h-5.6023759l5.7979035 5.0731656c.3325287.2909626.2421375.5268344-.2033799.5268344h-10.3945236z",
    fill: "url(#a)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "m0 0h1.19625244c.22298362 0 .55454063.10052872.73420129.22030249l8.60969937 5.73979959c.3644234.24294891.2974179.43989792-.1377772.43989792h-5.6023759l5.7979035 5.0731656c.3325287.2909626.2421375.5268344-.2033799.5268344h-10.3945236z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m.4.4v11.2h9.7354202l-6.39999996-5.6h6.14346952l-8.17031611-5.4468774c-.11475021-.07650014-.36927978-.1531226-.51232121-.1531226z",
    stroke: "url(#c)",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    d: "m4.11065217 4.68046044c.23046592-.0631595.44293461-.14954104.63085289-.25477584-.1863899.6770211-.80649658 1.1743154-1.54275256 1.1743154s-1.35636266-.4972943-1.54275256-1.1743154c.18843853.10552614.4015636.1920945.63276744.25529987l.31123262-.28098447-.50865544-.45922012.68439137.03495605-.03495605-.68439137.45922012.50865544.45922012-.50865544-.03495605.68439137.68439137-.03495605-.50865544.45922012zm-.91065217 4.91953956-.61229349.6782073.04660807-.91252186-.91252184.04660808.67820726-.61229352-.67820726-.61229352.91252184.04660808-.04660807-.91252182.61229349.67820726.61229349-.67820726-.04660807.91252182.91252184-.04660808-.67820726.61229352.67820726.61229352-.91252184-.04660808.04660807.91252186z",
    fill: "url(#a)",
    fillRule: "nonzero",
    mask: "url(#e)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNp);
export default __webpack_public_path__ + "static/media/NP.b85c105f56c9d9fec43cf1501c892707.svg";
export { ForwardRef as ReactComponent };